<template>
  <div class="row alerts" :class="{ 'alerts--hidden' : !showMessage }">
    <div class="col-12">
      <div :class="{ 'message-order-failed alert-danger' : error,
                     'message-order-succeed alert-success' : !error}"
           class="alert"
           v-html="messageName">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Errors',
    props: {
      message: {
        default: '',
      },
    },
    data() {
      return {
        messageName: '',
        error: false,
        errorType: '',
        showMessage: false,
        showCollapse: false,
        translationAttributes: '',
      };
    },
    methods: {
      checkResponse() {
        if (this.message.status === 200) {
          this.$emit('closeCollapse');
          this.error = false;
          this.messageName = this.I18n.t('simple_form.labels.order_form.created_html');
        } else {
          this.error = true;
          this.errorType = this.message.error;
          this.checkErrorMessage();
        }
        this.showMessage = true;
      },
      checkErrorMessage() {
        switch (this.message.error) {
          case 'too_long':
            this.messageName = `${this.I18n.t('activerecord.attributes.order.limit')}
                                ${this.I18n.t('activerecord.errors.models.order.attributes.limit.too_long')}`;
            break;
          case 'greater_than':
            this.messageName = `${this.I18n.t('activerecord.attributes.order.limit')}
                                ${this.I18n.t('activerecord.errors.models.order.attributes.limit.greater_than')}`;
            break;
          case 'invalid':
            this.messageName = `${this.I18n.t('activerecord.attributes.order.phone')}
                                ${this.I18n.t('activerecord.errors.models.order.attributes.phone.invalid')}`;
            break;
          case 'limit_multiplicity_higher':
            this.translationAttributes = { multiplicity_value: this.message.multiplicity_value };
            // falls through
          case 'limit_multiplicity_lower':
            this.translationAttributes = { multiplicity_value: this.message.multiplicity_value,
              limit_boundary: this.message.limit_boundary };
            // falls through
          default:
            this.messageName = this.I18n.t(`activerecord.errors.models.order.attributes.base.${this.errorType}`, this.translationAttributes);
        }
      },
    },
    watch: {
      message() {
        this.checkResponse();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/errors.vue?3b8c45b0